import { EngagementStatus, PaymentStatus, Role, TERMINAL_STATUSES, } from "@gigsync/protocol";
import { isAfterDay, isOnDay, recurs } from "./when.js";
const S = EngagementStatus.enum;
/** Signed and not over: the work is ahead, under way, handed over, or being redone. */
const ACTIVE = new Set([S.agreed, S.in_progress, S.delivered, S.revision]);
/**
 * Files each job once. A waiting decision wins over everything, so nothing the owner must answer is ever hidden.
 * `day` is the phone's own "YYYY-MM-DD".
 */
export function groupJobs({ jobs, tasks, payments, day }) {
    const open = new Set(tasks.map((k) => k.engagement));
    const paidFor = new Set(payments.filter((p) => p.status === PaymentStatus.enum.confirmed).map((p) => p.engagement));
    const groups = { decide: [], today: [], upcoming: [], other: [], talking: [], earlier: [] };
    const newest = [...jobs].sort((a, b) => b.engagement.created_at.localeCompare(a.engagement.created_at));
    for (const job of newest) {
        const id = job.engagement.id;
        shelf(groups, job, open.has(id), paidFor.has(id), day).push(job);
    }
    return groups;
}
function shelf(groups, job, decide, paid, day) {
    const status = job.engagement.status;
    if (decide)
        return groups.decide;
    if (TERMINAL_STATUSES.has(status) || (paid && settled(job)))
        return groups.earlier;
    if (!ACTIVE.has(status))
        return groups.talking;
    if (isOnDay(job.request, day))
        return groups.today;
    if (isAfterDay(job.request, day))
        return groups.upcoming;
    return groups.other;
}
/**
 * A paid one-off job has nothing left to do once the work is handed over. Paid before that (cash at the door), the
 * work is still ahead, under way or being redone, and its On my way and Mark done stay in view. A consumer's review
 * of delivered work keeps it in view too, until the review closes it. Monthly work recurs, so it never settles: it
 * leaves Agreed only once the arrangement ends (closed or cancelled).
 */
function settled(job) {
    if (recurs(job.request))
        return false;
    const e = job.engagement;
    if (e.status !== S.delivered)
        return false;
    return !(e.role === Role.enum.requester && !job.review);
}
//# sourceMappingURL=groups.js.map